import { useEffect, useState } from "react";
import { Button, Container, Spinner, Table } from "react-bootstrap";
import { useProfileContext } from "../contexts/ProfileContexts";
import { config } from "../config";
import {
  createCheckoutSession,
  createCustomerPortalSession,
} from "../graphql/queries";
import { DateTime } from "luxon";
import { Link } from "react-router-dom";
import { client } from "../App";
import { refreshMe } from "../utils";
import { useAuthenticator } from "@aws-amplify/ui-react";

const { prices } = config;

const localPlan = "diamond";

const Account = () => {
  const useAuthenticatorReturn = useAuthenticator();

  const cognitoUser = useAuthenticatorReturn.user;

  const { setProfile, setUser, user } = useProfileContext();

  useEffect(() => {
    console.log("cognito user", cognitoUser);
    if (cognitoUser) {
      refreshMe(setUser, setProfile);
    }
  }, [cognitoUser, setProfile, setUser]);

  const [loading, setLoading] = useState(false);
  const [billingFreq, setBillingFreq] = useState("daily");
  const [showToast, setShowToast] = useState(false);

  const handleChangePlan = async () => {
    // go to stripe checkout or customer portal
    const price = prices.find((p) => p.name === `${localPlan}-${billingFreq}`);
    if (price) {
      try {
        setLoading(true);
        const { data } = (await client.graphql({
          query: createCheckoutSession,
          variables: { priceId: price.priceId },
        })) as any;
        console.log({ data });
        window.location.href = data.createCheckoutSession.url;
      } catch (error) {
        setLoading(false);
        console.error(error);
      }
    }
  };

  const handleManageSubscription = async () => {
    if (user && user.stripeCustomerId) {
      const { stripeCustomerId } = user;
      console.log({ stripeCustomerId });
      const { data } = (await client.graphql({
        query: createCustomerPortalSession,
        variables: { stripeCustomerId },
      })) as any;
      console.log({ data });
      window.location.href = data.createCustomerPortalSession.url;
    }
  };

  const copyAndShowToast = () => {
    if (user && user.affiliateId) {
      navigator.clipboard.writeText(
        `https://miner25.stubminer.com/?affiliate=${user.affiliateId}`,
      );
      setShowToast(true);
      setTimeout(() => setShowToast(false), 3000);
    }
  };

  return (
    <Container className="center">
      <h1>Your Account</h1>
      <h3>{user?.email}</h3>
      <h4>
        You are currently on the{" "}
        <span className="strong">{user?.planname}</span> plan.
      </h4>
      {user && user.balance ? (
        <h4>
          You have ${(parseInt(user.balance) / -100).toFixed(2)} credit toward
          your next subscription
        </h4>
      ) : (
        ""
      )}
      <h5>
        {user &&
        user.planname !== "free" &&
        user.cancelAtPeriodEnd &&
        user.currentPeriodEnd
          ? `Your subscription will end ${DateTime.fromSeconds(
              user.currentPeriodEnd,
            ).toRelative()}`
          : ``}
        {user &&
        user.planname !== "free" &&
        !user.cancelAtPeriodEnd &&
        user.currentPeriodEnd
          ? `Your subscription will renew ${DateTime.fromSeconds(
              user.currentPeriodEnd,
            ).toRelative()}`
          : ``}
      </h5>
      {user && user.affiliateId && (
        <h5>
          Your affiliate ID is {user?.affiliateId}{" "}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-share"
            viewBox="0 0 16 16"
            onClick={copyAndShowToast}
            style={{ cursor: "pointer" }}
          >
            <path d="M13.5 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.5 2.5 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5m-8.5 4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m11 5.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3" />
          </svg>
          &nbsp;
          <Link
            to="/faq"
            className="rounded-circle border border-dark text-sm h6 cursor-pointer"
            style={{ width: "20px", height: "20px", display: "inline-table" }}
          >
            ?
          </Link>
        </h5>
      )}
      <Table>
        <tbody>
          <tr>
            <td className="centered">Diamond Plan</td>
          </tr>
          <tr>
            <td>
              <ul>
                <li>
                  {billingFreq === "daily"
                    ? "$9.99 per day"
                    : billingFreq === "weekly"
                      ? "$49.99 per week"
                      : "$149.99 per month"}
                </li>
                <li>Flip Any Cards You Want</li>
                <li>
                  Estimated{" "}
                  {billingFreq === "daily"
                    ? "200,000 stubs per day"
                    : billingFreq === "weekly"
                      ? "1,400,000 stubs per week"
                      : "5,000,000 stubs per month"}
                </li>
                <li>Mine with 3 cards at a time</li>
                <li>See if your cards are being mined by other users</li>
              </ul>
            </td>
          </tr>
          <tr>
            <td colSpan={4}>
              <Table>
                <tbody>
                  <tr>
                    <td colSpan={2} className="centered">
                      <Button
                        disabled={billingFreq === "daily"}
                        onClick={() => setBillingFreq("daily")}
                      >
                        Billed Daily
                      </Button>
                    </td>
                    <td colSpan={2} className="centered">
                      <Button
                        disabled={billingFreq === "weekly"}
                        onClick={() => setBillingFreq("weekly")}
                      >
                        Billed Weekly
                      </Button>
                    </td>
                    <td colSpan={2} className="centered">
                      <Button
                        disabled={billingFreq === "monthly"}
                        onClick={() => setBillingFreq("monthly")}
                      >
                        Billed Monthly
                      </Button>
                    </td>
                  </tr>
                </tbody>
              </Table>
            </td>
          </tr>
        </tbody>
      </Table>
      {user && user.planname === "free" && (
        <Button
          onClick={handleChangePlan}
          disabled={
            localPlan.split("-")[0] === "free" ||
            `${localPlan}-${billingFreq}` === user.planname ||
            loading
          }
          variant="success"
          className="mt-4 btn-lg"
        >
          {`Create ${
            localPlan.split("-")[0].charAt(0).toUpperCase() +
            localPlan.split("-")[0].slice(1)
          } Subscription`}
        </Button>
      )}
      {user && user.planname !== "free" && (
        <Button
          variant="success"
          className="mt-4 btn-lg"
          onClick={handleManageSubscription}
        >
          Manage Subscription
        </Button>
      )}
      {loading && <Spinner animation="border" variant="success" />}
      <div className="position-fixed bottom-0 end-0 p-3" style={{ zIndex: 11 }}>
        <div
          id="liveToast"
          className={`toast ${!showToast ? "hide" : "show"}`}
          role="alert"
          aria-live="assertive"
          aria-atomic="true"
        >
          <div className="toast-header">
            <strong className="me-auto">Copied</strong>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="toast"
              aria-label="Close"
              onClick={() => setShowToast(false)}
            ></button>
          </div>
          <div className="toast-body">
            Your affiliate link was copied to your clipboard!
          </div>
        </div>
      </div>
    </Container>
  );
};

export default Account;
